export const BRAND_NAME = 'Contrataê Bahia';
export const BRAND_SLOGAN = 'Oportunidades para quem faz acontecer.';
export const BRAND_EMAIL = 'contato@contrataebahia.com.br';
export const BRAND_WHATSAPP = 'https://wa.me/5571999999999';
export const APP_URL = process.env.REACT_APP_APP_URL || '';
export const LOGO_SRC = '/assets/images/contrataebahia-logo.png';
export const SYMBOL_SRC = '/assets/images/contrataebahia-symbol.png';
